export const SIGNALS_REST_API_CONFIGURED_QUERY_KEY = "management:signals-rest-api-configured";
